import pako from 'pako'

const encode = (options) => {
  const hash = JSON.stringify(options)
  const compressed = pako.deflate(hash)
  const base64 = btoa(String.fromCharCode.apply(null, compressed))
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export default encode